import { useState } from "react";
import useUsuarios from "../../hooks/useUsuarios";

const CadastrarUsuario = () => {

  const { cadastrarUsuario } = useUsuarios();
  const [actionType, setActionType] = useState(null);
  const [usuario, setUsuario] = useState({
    nome: "",
    cpf: "",
    profissao: "",
    numeroOab: "",
    vinculo: "",
    email: "",
    senha: "",
    role: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUsuario({
      ...usuario,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setActionType("cadastrar");
    try {
      await cadastrarUsuario(usuario);
      alert("Usuário cadastrado com sucesso!");

      setUsuario({
        nome: "",
        cpf: "",
        profissao: "",
        numeroOab: "",
        vinculo: "",
        email: "",
        senha: "",
        role: ""
      });

    } catch (error) {
      alert(error.response?.data?.erro || "Erro ao cadastrar");
    } finally {
      setActionType(null);
    }
  };

  return (
    <div className="container">
      <div className="card">

        <h1>CADASTRAR USUÁRIO</h1>
        <hr />

        <form onSubmit={handleSubmit}>
          <div className="form-grid">

            <div className="form-group">
              <label>Nome</label>
              <input
                type="text"
                name="nome"
                value={usuario.nome}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>CPF</label>
              <input
                type="Number"
                name="cpf"
                value={usuario.cpf}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={usuario.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Senha</label>
              <input
                type="password"
                name="senha"
                value={usuario.senha}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Profissão</label>
              <select
                name="profissao"
                value={usuario.profissao}
                onChange={handleChange}
                required
              >
                <option value="">Selecione</option>
                <option value="advogado">Advogado</option>
                <option value="assessor_juridico">Assessor Jurídico</option>
                <option value="estagiario">Estagiário</option>
                <option value="recepcionista">Recepcionista</option>
              </select>
            </div>

            {usuario.profissao === "advogado" && (
              <div className="form-group">
                <label>Nº OAB</label>
                <input
                  type="text"
                  name="numeroOab"
                  value={usuario.numeroOab}
                  onChange={handleChange}
                  required
                />
              </div>
            )}

            <div className="form-group">
              <label>Vínculo</label>
              <select
                name="vinculo"
                value={usuario.vinculo}
                onChange={handleChange}
                required
              >
                <option value="">Selecione</option>
                <option value="interno">Interno</option>
                <option value="parceiro">Parceiro</option>
              </select>
            </div>

            <div className="form-group">
              <label>Perfil do Sistema</label>
              <select
                name="role"
                value={usuario.role}
                onChange={handleChange}
                required
              >
                <option value="">Selecione</option>
                <option value="advogado">Advogado</option>
                <option value="advogado_parceiro">Advogado Parceiro</option>
                <option value="assessor_juridico">Assessor Jurídico</option>
                <option value="estagiario">Estagiário</option>
                <option value="recepcionista">Recepcionista</option>
                <option value="ti">TI</option>
              </select>
            </div>

            <div className="form-buttons">
              <button 
                type="submit"
                disabled={actionType !== null}
              >
                {actionType === "cadastrar" ? (
                  <span className="spinner-loader"></span>
                ) : (
                  "Cadastrar Usuário"
                )}
              </button>
            </div>

          </div>
        </form>

      </div>
    </div>
  );
};

export default CadastrarUsuario;